"use strict";

exports.__esModule = true;
exports.legendContentFormatter = void 0;
var _react = _interopRequireDefault(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _Theme = require("../../../Theme");
var _getDataItemLabel = require("../getDataItemLabel");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var DataItemLabel = _styledComponents["default"].span.withConfig({
  displayName: "legendContentFormatter__DataItemLabel",
  componentId: "sc-dhrk05-0"
})(["color:", ";"], function (props) {
  return props.color || (0, _Theme.val)("DefaultChartColor");
});
var AverageWrapper = _styledComponents["default"].span.withConfig({
  displayName: "legendContentFormatter__AverageWrapper",
  componentId: "sc-dhrk05-1"
})(["padding:0px 4px;border:1px solid ", ";margin-left:3px;color:", ";border-radius:10px;"], function (props) {
  return props.color || (0, _Theme.val)("DefaultChartColor");
}, function (props) {
  return props.color || (0, _Theme.val)("DefaultChartColor");
});
var legendContentFormatter = exports.legendContentFormatter = function legendContentFormatter(data) {
  return function (value) {
    var dataItemProps = data.find(function (dataItemData) {
      return dataItemData.name === value;
    });
    if (!dataItemProps) {
      return null;
    }
    return /*#__PURE__*/_react["default"].createElement("div", {
      style: {
        marginTop: "2px",
        display: "inline"
      }
    }, /*#__PURE__*/_react["default"].createElement(DataItemLabel, {
      color: dataItemProps.color
    }, dataItemProps ? (0, _getDataItemLabel.getDataItemLabel)(dataItemProps) : null), dataItemProps.isAverage ? /*#__PURE__*/_react["default"].createElement(AverageWrapper, {
      color: dataItemProps.color
    }, "Average") : null);
  };
};